<template>
  <div>
    <hero-small :background="require('@/assets/oil-gas-finder-header.jpg')">
      <h1 class="text-white bold m-0 text-uppercase">
        {{$t('oilGasFinder.header')}}
      </h1>
    </hero-small>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-11 py-5">
          <h3 class="text-lg mb-4" v-html="$t('oilGasFinder.description.header')"></h3>
          <p class="text-sm" v-html="$t('oilGasFinder.description.text1')"></p>
          <p class="text-sm">
            <span>{{$t('oilGasFinder.description.text2')}}</span><br>
            <i18n path="oilGasFinder.description.text3" tag="span">
              <localized-link :to="{name: 'Privacy Policy', hash: '#disclaimer'}">
                <span class="text-underline text-lowercase">{{ $t('menu.disclaimer') }}</span>
              </localized-link>
            </i18n>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h3 class="text-sm bold form-header d-inline-block pb-1 px-1 mb-0">
            {{$t('oilGasFinder.filtersHeader')}}
          </h3>
        </div>
      </div>
    </div>
    <section class="filters-form py-5">
      <div class="container">
        <div class="row">
          <div class="col">
            <form id="finder-form" class="finder-form">
              <b-input-group id="input-group-brand" class="select-input-group">
                <div class="select-spinner">
                  <b-spinner v-if="brandsLoading" variant="secondary" small></b-spinner>
                </div>
                <b-form-select v-model="selectedBrand" :options="brandsOptions"></b-form-select>
              </b-input-group>
              <b-input-group id="input-group-model" class="select-input-group">
                <div class="select-spinner">
                  <b-spinner v-if="modelsLoading" variant="secondary" small></b-spinner>
                </div>
                <b-form-select v-model="selectedModel"
                               :options="modelsOptions"
                               :disabled="!selectedBrand"></b-form-select>
              </b-input-group>
              <b-input-group id="input-group-engine" class="select-input-group">
                <div class="select-spinner">
                  <b-spinner v-if="enginesLoading" variant="secondary" small></b-spinner>
                </div>
                <b-form-select v-model="selectedEngine"
                               :options="enginesOptions"
                               :disabled="!selectedBrand || !selectedModel"></b-form-select>
              </b-input-group>
              <b-input-group id="input-group-manufactured-from" class="select-input-group">
                <div class="select-spinner">
                  <b-spinner v-if="manufacturedDatesLoading" variant="secondary" small></b-spinner>
                </div>
                <b-form-select v-model="seletedManufacturedDate"
                               :options="manufacturedDatesOptions"
                               :disabled="!selectedBrand || !selectedModel || !selectedEngine"></b-form-select>
              </b-input-group>
              <div>
                <b-icon @click="resetFilters" icon="arrow-repeat" class="text-xl text-secondary pointer"></b-icon>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <div v-if="resultsLoading" class="d-flex justify-content-center my-5">
      <b-spinner variant="secondary"></b-spinner>
    </div>
    <div v-else>
      <div v-if="results" id="results">
        <OilGasFinderResultsDesktop :results="results" />
        <OilGasFinderResultsMobile :results="results" />
      </div>
    </div>
    <section class="descriptions container py-5">
      <div class="row">
        <div class="col">
          <OilGasFinderAbbreviationDescriptions />
        </div>
      </div>
    </section>
    <section class="container">
      <div class="row">
        <div v-if="relatedMaterials.length" class="col-12 col-lg-9 mt-5">
          <h3 class="text-uppercase text-sm bold pb-1 px-1 mb-4">{{$t('common.relatedMaterials')}}</h3>
          <div>
            <div v-for="material in relatedMaterials" :key="material.id"
                class="mb-4">
              <SearchItem :material="material" />
            </div>
            <div class="py-1"
                 v-view="handleLoadingMoreRelatedMaterials" >
              <div v-if="relatedMaterialsLoadingMore">
                <div class="mb-4">
                  <SearchItemSkeleton />
                </div>
                <div class="mb-4">
                  <SearchItemSkeleton />
                </div>
              </div>
            </div>
            <div v-if="!relatedMaterialsReachedTheEnd && !relatedMaterialsLoadingMore && isMobile()" class="text-center">
              <button class="btn btn-secondary mb-5 text-uppercase"
                      @click="getRelatedMaterials(true)">
                  {{$t('common.loadMore')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HeroSmall from '@/components/HeroSmall.vue';
import OilGasFinderAbbreviationDescriptions from '@/components/oil-gas-finder/OilGasFinderAbbreviationDescriptions.vue';
import OilGasFinderResultsDesktop from '@/components/oil-gas-finder/OilGasFinderResultsDesktop.vue';
import OilGasFinderResultsMobile from '@/components/oil-gas-finder/OilGasFinderResultsMobile.vue';
import SearchItem from '@/components/SearchItem.vue';
import SearchItemSkeleton from '@/components/SearchItemSkeleton.vue';

export default {
  metaInfo() {
    return {
      title: 'Oil & Gas Finder - Nisssens Support',
    };
  },
  components: {
    HeroSmall,
    OilGasFinderAbbreviationDescriptions,
    OilGasFinderResultsDesktop,
    OilGasFinderResultsMobile,
    SearchItem,
    SearchItemSkeleton,
  },
  data() {
    return {
      brandsOptions: this.setInitialOptionsValue(this.$t('oilGasFinder.make')),
      selectedBrand: null,
      modelsOptions: this.setInitialOptionsValue(this.$t('oilGasFinder.model')),
      selectedModel: null,
      enginesOptions: this.setInitialOptionsValue(this.$t('oilGasFinder.engine')),
      selectedEngine: null,
      manufacturedDatesOptions: this.setInitialOptionsValue(this.$t('oilGasFinder.from')),
      seletedManufacturedDate: null,
    };
  },
  computed: {
    ...mapGetters({
      brands: 'oilGasFinder/brands',
      brandsLoading: 'oilGasFinder/brandsLoading',
      models: 'oilGasFinder/models',
      modelsLoading: 'oilGasFinder/modelsLoading',
      engines: 'oilGasFinder/engines',
      enginesLoading: 'oilGasFinder/enginesLoading',
      manufacturedDates: 'oilGasFinder/manufacturedDates',
      manufacturedDatesLoading: 'oilGasFinder/manufacturedDatesLoading',
      results: 'oilGasFinder/results',
      resultsLoading: 'oilGasFinder/resultsLoading',
      tagsForRelatedMaterials: 'oilGasFinder/tagsForRelatedMaterials',
      relatedMaterials: 'oilGasFinder/relatedMaterials',
      relatedMaterialsLoadingMore: 'oilGasFinder/relatedMaterialsLoadingMore',
      relatedMaterialsReachedTheEnd: 'oilGasFinder/relatedMaterialsReachedTheEnd',
    }),
  },
  watch: {
    brands(updatedData) {
      this.brandsOptions = this.setFormOptions(updatedData, this.$t('oilGasFinder.make'));
    },
    selectedBrand(brand) {
      this.selectedModel = null;
      this.selectedEngine = null;
      this.seletedManufacturedDate = null;
      if (brand) {
        this.getModels(brand);
      }
    },
    models(updatedData) {
      this.modelsOptions = updatedData
        ? this.setFormOptions(updatedData, this.$t('oilGasFinder.model')) : this.setInitialOptionsValue(this.$t('oilGasFinder.model'));
    },
    selectedModel(model) {
      this.selectedEngine = null;
      this.seletedManufacturedDate = null;
      if (model) {
        this.getEngines(model);
        this.getResults();
      }
    },
    engines(updatedData) {
      this.enginesOptions = updatedData
        ? this.setFormOptions(updatedData, this.$t('oilGasFinder.engine')) : this.setInitialOptionsValue(this.$t('oilGasFinder.engine'));
    },
    selectedEngine() {
      this.seletedManufacturedDate = null;
      this.getManufacturedDates();
      this.getResults();
    },
    manufacturedDates(updatedData) {
      this.manufacturedDatesOptions = updatedData
        ? this.setFormOptions(updatedData, this.$t('oilGasFinder.from')) : this.setInitialOptionsValue(this.$t('oilGasFinder.from'));
    },
    seletedManufacturedDate() {
      this.getResults();
    },
  },
  mounted() {
    this.getBrands();
    if (this.tagsForRelatedMaterials.length) {
      this.getRelatedMaterials();
    } else {
      this.$store.dispatch('oilGasFinder/GET_TAGS').then((tags) => {
        if (tags.length) {
          this.getRelatedMaterials();
        }
      });
    }
  },
  methods: {
    setFormOptions(data, firstValueText) {
      const dataWithoutBlankFields = data.filter((element) => element !== '');
      const options = dataWithoutBlankFields.map((element) => {
        return {
          value: element,
          text: element,
        };
      });
      options.unshift({
        value: null,
        text: `-- ${firstValueText} --`,
      });
      return options;
    },
    setInitialOptionsValue(firstValueText) {
      return [{ value: null, text: `-- ${firstValueText} --` }];
    },
    getBrands() {
      this.$store.dispatch('oilGasFinder/GET_BRANDS');
    },
    getModels(brand) {
      this.$store.dispatch('oilGasFinder/GET_MODELS', brand);
    },
    getEngines(model) {
      this.$store.dispatch('oilGasFinder/GET_ENGINES', model);
    },
    getManufacturedDates() {
      const data = {
        model: this.selectedModel,
        engine: this.selectedEngine,
      };
      this.$store.dispatch('oilGasFinder/GET_MANUFACTURED_DATES', data);
    },
    getResults() {
      if (this.selectedBrand && this.selectedModel) {
        const data = {
          make: this.selectedBrand,
          model: this.selectedModel,
          engine: this.selectedEngine,
          manufactured_from: this.seletedManufacturedDate,
        };
        this.$store.dispatch('oilGasFinder/GET_RESULTS', data);
      }
    },
    resetFilters() {
      this.selectedBrand = null;
      this.modelsOptions = this.setInitialOptionsValue(this.$t('oilGasFinder.model'));
      this.selectedModel = null;
      this.enginesOptions = this.setInitialOptionsValue(this.$t('oilGasFinder.engine'));
      this.selectedEngine = null;
      this.manufacturedDatesOptions = this.setInitialOptionsValue(this.$t('oilGasFinder.from'));
      this.seletedManufacturedDate = null;
      this.$store.dispatch('oilGasFinder/RESET');
    },
    getRelatedMaterials(loadingMore = false) {
      this.$store.dispatch('oilGasFinder/GET_RELATED_MATERIALS', { loadingMore });
    },
    handleLoadingMoreRelatedMaterials(e) {
      if (e.type === 'enter' && !this.relatedMaterialsReachedTheEnd && !this.isMobile()) {
        this.getRelatedMaterials(true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.form-header {
  border-bottom: 3px solid $tertiary;
}
form.finder-form {
  display: flex;
  align-items: center;
  > div:not(:last-child) {
    margin-right: 15px;
  }
  @include media-breakpoint-down(md) {
    flex-direction: column;
    align-items: flex-start;
    > div:not(:last-child) {
      margin-right: 0;
      margin-bottom: 15px;
    }
  }
}
section.filters-form {
  background-color: $light-grey;
}
.select-input-group {
  position: relative;
  .select-spinner {
    position: absolute;
    left: 10px; top: 0;
    z-index: 9;
    height: 100%;
    display: flex;
    align-items: center;
  }
  select {
    @extend .text-xs;
    text-transform: uppercase;
    border-radius: 0;
    border: 1px solid #dfdfdf;
    padding-left: 35px;
    font-weight: bold;
    color: $primary;
  }
}

@include media-breakpoint-down (md) {
  .search-results {
    display: none;
  }
  .search-results-mobile {
    display: block;
  }
}
</style>
